import { createFileRoute, redirect } from '@tanstack/react-router';
import { publicEstimateSearch } from '@/lib/sales/public-estimate-search';

/** Keep previously shared links and payment returns working. */
export const Route = createFileRoute('/(public)/quote/$id')({
  validateSearch: publicEstimateSearch,
  beforeLoad: ({ params, location, search }) => {
    throw redirect({
      to: '/estimate/$id',
      params: { id: params.id },
      search: { ...location.search, ...search },
      hash: location.hash,
      replace: true,
    });
  },
});
